// extracted by mini-css-extract-plugin
export var auto = "_3f-1";
export var spinner = "_3f-0";